import { A } from "@solidjs/router";
import { For, Show } from "solid-js";
import type { DeliveryBrief } from "../brief/briefTypes";
import { governanceNextAction } from "./governGuidance";
import { governanceStateLabel } from "./governStatus";
import type { GovernWorkItem } from "./governTypes";

export function GovernQueue(props: {
  works: GovernWorkItem[];
  briefs: DeliveryBrief[];
  selectedId: string | null;
  websiteId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <aside class="govern-queue" aria-label="Governed work">
      <header>
        <span class="signal-mini-kicker">Controlled delivery</span>
        <h2>Work queue</h2>
        <p>Briefs opened in Govern during this Preview session.</p>
      </header>
      <Show
        when={props.works.length > 0}
        fallback={
          <div class="govern-empty-queue">
            <strong>No work has entered Govern</strong>
            <p>Only a Brief marked Ready for delivery can be started here.</p>
            <A href={`/w/${props.websiteId}/brief`}>Open Brief</A>
          </div>
        }
      >
        <div class="govern-queue-list" role="listbox" aria-label="Govern work">
          <For each={props.works}>
            {(work) => (
              <button
                type="button"
                role="option"
                class={`govern-queue-item${props.selectedId === work.id ? " is-selected" : ""}`}
                aria-selected={props.selectedId === work.id}
                onClick={() => props.onSelect(work.id)}
              >
                <span>{work.sourceSnapshot.source.label}</span>
                <strong>{work.sourceSnapshot.title}</strong>
                <small>
                  {work.sourceSnapshot.pages.length || "Scope unavailable"}
                  {work.sourceSnapshot.pages.length === 1
                    ? " page"
                    : work.sourceSnapshot.pages.length > 1
                      ? " pages"
                      : ""}
                  {work.roles.deliveryOwner
                    ? ` / ${work.roles.deliveryOwner}`
                    : " / Owner not assigned"}
                </small>
                <em>{governanceStateLabel(work.state)}</em>
                <i>
                  {
                    governanceNextAction(
                      work,
                      props.briefs.find(
                        (brief) => brief.id === work.sourceBriefId,
                      ) ?? null,
                    ).action
                  }
                </i>
              </button>
            )}
          </For>
        </div>
      </Show>
    </aside>
  );
}
